import React from 'react';
import Diposit_History_card from './deposit_History_card/Diposit_History_card';

function Deposit_History_list_contant() {
  const depositData = [
    {
      imgSrc: "/assets/images/services/bank_logo/bank_of_maharashtra.png",
      title: "Deposit to Wallet",
      amount: 399,
      status: "Failed",
      note: "Debited",
      time: "48 minutes ago",
    },
    {
      imgSrc: "/assets/images/services/bank_logo/bank_of_maharashtra.png",
      title: "Deposit via Paytm",
      amount: 250,
      status: "Success",
      note: "Credited",
      time: "2 hours ago",
    },
    {
      imgSrc: "/assets/images/services/bank_logo/bank_of_maharashtra.png",
      title: "Deposit via UPI",
      amount: 799,
      status: "Pending",
      note: "Processing",
      time: "3 hours ago",
    },
    {
      imgSrc: "/assets/images/services/bank_logo/bank_of_maharashtra.png",
      title: "Deposit via Bank Transfer",
      amount: 1200,
      status: "Success",
      note: "Credited",
      time: "1 day ago",
    },
    {
      imgSrc: "/assets/images/services/bank_logo/bank_of_maharashtra.png",
      title: "Deposit via Google Pay",
      amount: 300,
      status: "Failed",
      note: "Debited",
      time: "2 days ago",
    },
    {
      imgSrc: "/assets/images/services/bank_logo/bank_of_maharashtra.png",
      title: "Deposit via PhonePe",
      amount: 650,
      status: "Success",
      note: "Credited",
      time: "4 days ago",
    },
  ];

  return (
    <section className='Withdraw_History_list_contant'>
      <div className="row">
        {depositData.map((item, index) => (
          <div className="col-sm-6" key={index}>
            <Diposit_History_card
              imgSrc={item.imgSrc}
              title={item.title}
              amount={item.amount}
              status={item.status}
              note={item.note}
              time={item.time}
            />
          </div>
        ))}
      </div>
    </section>
  );
}

export default Deposit_History_list_contant;
